// extracted by mini-css-extract-plugin
export default {"pagenotfound_wrap":"pagenotfound_pagenotfound_wrap__wJdeT","back_btn":"pagenotfound_back_btn__kcTfV"};